// canvas-page 配下で共有する RealtimeClient のコンテキスト。
// CanvasView がマウント時にクライアントを初期化し、子コンポーネントは
// useRealtimeClient() から sendOp / sendMessage を取り出して使う。

import { createContext, useContext, type ReactNode } from "react";
import type { RealtimeClient } from "./realtime-client";

const RealtimeContext = createContext<RealtimeClient | null>(null);

interface ProviderProps {
  readonly client: RealtimeClient;
  readonly children: ReactNode;
}

export function RealtimeClientProvider({ client, children }: ProviderProps): ReactNode {
  return <RealtimeContext.Provider value={client}>{children}</RealtimeContext.Provider>;
}

export function useRealtimeClient(): RealtimeClient {
  const client = useContext(RealtimeContext);
  if (!client) {
    throw new Error(
      "RealtimeClient が未提供です。CanvasView 配下で useRealtimeClient を使用してください。"
    );
  }
  return client;
}
